import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Payments (/payments)
 */
export const paymentsTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Payments_Welcome_Title"),
    description: t("Tour_Payments_Welcome_Description"),
    target: () => queryTourTarget("payments-table-section"),
    placement: "bottom",
  },
  {
    title: t("Tour_Payments_Status_Title"),
    description: t("Tour_Payments_Status_Description"),
    target: () => queryTourTarget("payments-status-filter"),
    placement: "bottom",
  },
  {
    title: t("Tour_Payments_Approve_Title"),
    description: t("Tour_Payments_Approve_Description"),
    target: () => queryTourTarget("payments-approve"),
    placement: "left",
  },
];
